import { Container, Spacer } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import React from "react";
import { Platform } from "react-native";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { Image as RNImage } from "react-native";
import { Image as ExpoImage } from "expo-image";
import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { DefaultTheme } from "styled-components/native";

const CustomLogo = ({ onLoadComplete }: { onLoadComplete?: () => void }) => {
  const userInfo = useUserInfo();
  const theme = useTheme();
  const overlayHeight = userInfo.customLogoURL ? "auto" : "0px";
  const { deviceWidth: screenWidth } = useIsFoldable();
  if (
    theme.isLargeScreen &&
    !userInfo.hideCustomLogo &&
    userInfo.customLogoURL
  ) {
    return <img style={{ height: "100%" }} src={userInfo.customLogoURL} />;
  }
  const ImageComponent = Platform.OS !== "ios" ? RNImage : ExpoImage;

  const LogoImage = styled(ImageComponent)`
    height: 128px;
    width: 343px;
  `;

  return (
    <Container
      {...(!theme.isLargeScreen && {
        maxWidth: screenWidth,
        noPadding: true,
      })}
    >
      <OverLay height={overlayHeight}>
        <Spacer size={SpaceType.Double} />
        {!userInfo.hideCustomLogo && userInfo.customLogoURL && (
          <LogoImage
            source={{
              uri: userInfo.customLogoURL,
            }}
            onLoadStart={() => onLoadComplete?.()}
            onError={() => onLoadComplete?.()}
            {...(Platform.OS === "ios"
              ? { contentFit: "contain" }
              : { resizeMode: "contain" })}
          />
        )}
      </OverLay>
    </Container>
  );
};

const OverLay = styled.View<{ height: string }>`
  height: ${({ height }: { height: string }) => height};
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }: { theme: DefaultTheme }) =>
    theme["header-bg-static"]};
`;

export default CustomLogo;
